import { withRouter } from 'react-router-dom';
import { UserConsumer } from '../../core/providers/UserProvider';
import { makeCancelable } from '../../core/utils/utils';
import PropTypes from 'prop-types';
import React from 'react';
import AddSubscriptionDialog from './AddSubscriptionDialog';
import GS from '../../grafsync/grafsync';
import Errored from '../Errored';

const allowMultipleTrials = process.env.REACT_APP_ALLOW_MULTIPLE_TRIALS === "true";

class AddSubscriptionContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isErrored: false,
            disabled: false
        };
        this.cancellable = null;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    processSuccess = (subscriptionId) => () => {
        this.props.onNewSubscription(subscriptionId);
    };

    addSubscription = (user) => async (data) => {
        try {
            const subscription = await this.doCreateSubscription(data).promise;
            const subscriptionInfo = await subscription.json();
            // 0 Indicates a trial
            if (data.productID !== 0) {
                const Paddle = window.Paddle;
                try {
                    Paddle.Checkout.open({
                        product: data.productID,
                        email: user.email,
                        passthrough: "{\"token\": \"" + subscriptionInfo.subscriptionToken + "\", \"id\": \"" + subscriptionInfo.id + "\", \"user\": \"" + user.id + "\", \"name\": \"" + data.name + "\"}",
                        successCallback: this.processSuccess(subscriptionInfo.id)
                    });
                }
                catch (e) {
                    console.log(e);// eslint-disable-line
                    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: {message: "We cannot connect to Paddle at the moment. Please try again later."} });
                }
            }
            else {
                this.props.onNewSubscription(subscriptionInfo.id);
            }
        }
        catch (e) {
            if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
        }
    };

    doCreateSubscription(data) {
        this.cancellable = makeCancelable(GS.createSubscription(data.name, data.productID));
        return this.cancellable;
    }

    render() {

        const { disabled, isErrored } = this.state;
        const { subscriptions, name, inverted, selected, permitTrial } = this.props;
        const hasTrial = subscriptions && subscriptions.some(subItem => subItem.subscriptionType === "Trial");
        const subscriptionOptions = GS.subscriptionOptions();
        const options = subscriptionOptions.filter(subItem => !subItem.withdrawn && (!subItem.free || allowMultipleTrials || (permitTrial && !hasTrial)));

        if (isErrored) return <Errored data={isErrored} />;

        return (
            <UserConsumer>
                {({ user }) =>
                    <AddSubscriptionDialog
                        buttonTitle={name}
                        inverted={inverted}
                        selected={selected}
                        disabled={disabled}
                        options={options}
                        subscriptions={subscriptions}
                        onAddSubscription={this.addSubscription(user)} />
                }
            </UserConsumer>

        );
    }
}

AddSubscriptionContainer.defaultProps = {
    permitTrial: true
};

AddSubscriptionContainer.propTypes = {
    permitTrial: PropTypes.bool,
    onNewSubscription: PropTypes.func.isRequired,
    setSubscription: PropTypes.func.isRequired,
    name: PropTypes.string,
    selected: PropTypes.string,
    inverted: PropTypes.bool,
    subscriptions: PropTypes.array
};

export default withRouter(AddSubscriptionContainer);
